import { useState } from "react";
import { CaretDown } from "@phosphor-icons/react";

const LANGS = [
  { code: "tr", label: "TR", enabled: true },
  { code: "en", label: "EN", enabled: false },
  { code: "de", label: "DE", enabled: false },
];

export const LanguageSwitcher = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="relative" data-testid="language-switcher">
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1 border border-border px-2.5 py-1.5 text-xs font-mono font-bold hover:border-brand transition-colors"
      >
        TR <CaretDown size={12} weight="bold" />
      </button>
      {open && (
        <div className="absolute right-0 mt-1 z-50 bg-background border border-border min-w-[120px] shadow-sm">
          {LANGS.map((l) => (
            <button
              key={l.code}
              disabled={!l.enabled}
              data-testid={`lang-option-${l.code}`}
              className={`w-full flex items-center justify-between px-3 py-2 text-xs font-mono text-left ${
                l.enabled ? "hover:bg-muted font-bold" : "text-muted-foreground cursor-not-allowed"
              }`}
              onClick={() => l.enabled && setOpen(false)}
            >
              {l.label}
              {!l.enabled && <span className="text-[10px] normal-case">yakında</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
